import * as httpClient from '../utils/httpClient';
import { getBoatAdsQuery } from '../utils/requestHelpers';
import { AD_PAGE_KEY } from '../utils/ads/adsUtils';
import { getConfig } from '../config/portal';
import * as types from '../store/constants';

const fetchSBPData = async (params, imtID, requestContext, http) => {
  try {
    const headers = requestContext?.headers;
    if (http && headers) {
      headers['x-type-portal'] = types.HEADER_PORTAL_TYPE;
    }
    const apiClient = httpClient.getHttpClient(headers);
    const endPoint = `/search/boat/related/${imtID}`;
    const { zoneIds, kwArray } = getBoatAdsQuery(getConfig(), 'mobile', false, AD_PAGE_KEY.SBP);
    const requestData = {
      params: {
        ...params,
        pageSize: 27,
        zoneIds,
        hasTargetedAdsConsent: false,
        kwArray
      },
    };

    const response = await apiClient.get(endPoint, requestData);

    return { error: null, response };
  } catch (error) {
    return { error, response: null };
  }
};


export {
  fetchSBPData
};
